const REQUEST_MONITOR_PRODUCT_MATCHES = 'platfi-ui-app/MONITOR/REQUEST_MONITOR_PRODUCT_MATCHES';
const REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS =
  'platfi-ui-app/MONITOR/REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS';
const REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE =
  'platfi-ui-app/MONITOR/REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE';

export {
  REQUEST_MONITOR_PRODUCT_MATCHES,
  REQUEST_MONITOR_PRODUCT_MATCHES_SUCCESS,
  REQUEST_MONITOR_PRODUCT_MATCHES_FAILURE,
};
